export default __webpack_public_path__ + "static/media/power-simm-outlines.a073b1d1.svg";